import Store from "../store/store"

export function finishContent(id){
  return axios.get(`/api/v1/student/content/finish/${id}`)
}

export function accessContent(id){
  Store.commit("SET_ACCESSING_CONTENT", true)
  return axios.get(`/api/v1/student/content/access/${id}`)
  .finally(() => Store.commit("SET_ACCESSING_CONTENT", false))
}

export function rateContent(id, data){
  return axios.post(`/api/v1/student/content/rate/${id}`, data)
}
